import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["children", "decorator", "help", "input", "legend", "meta"];
import * as React from 'react';
var decorateControl = function decorateControl(Control, Decorator) {
  return function (props) {
    var children = props.children,
      decorator = props.decorator,
      help = props.help,
      input = props.input,
      legend = props.legend,
      meta = props.meta,
      extraProps = _objectWithoutProperties(props, _excluded);

    // $FlowFixMe[cannot-spread-inexact]
    var fieldProps = _objectSpread(_objectSpread(_objectSpread({}, input), extraProps), {}, {
      isField: true
    });
    return /*#__PURE__*/React.createElement(Decorator, props, /*#__PURE__*/React.createElement(Control, fieldProps, children));
  };
};
export default decorateControl;